import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import routesArr from "../../routes";
import Sidebar from "../sidebar/sidebar";
import { PreviousLocationProvider } from "./PreviousLocationContext";

function getRoutes(routesParamArr) {
  let arr = [];
  let dummyArr = [];
  return routesParamArr.map((prop, key) => {
    if (prop.collapse == true) {
      return getRoutes(prop.views);
    }
    if (prop.layout === "/admin") {
      return (
        <Route path={prop.path} Component={prop.component} key={key} />
        // <Route
        //   path={prop.layout + prop.path}
        //   component={prop.component}
        //   key={key}
        // />
      );
    } else {
      return null;
    }
  });

  // for (let i = 0; i < routesParamArr.length; i++) {

  //     if (routesParamArr[i].collapse == true) {
  //         getRoutes(routesParamArr[i].views);
  //     } else {
  //         if (routesParamArr[i].layout === "/admin" ) {
  //             arr.push( <Route path={routesParamArr[i].path} Component={routesParamArr[i].component} key={i} />);
  //             dummyArr.push(routesParamArr[i].path);
  //         }             
  //     }
  // } 
  // return arr;
};

function WithSidebar(props) {
  const location = useLocation();
  const [isSidebar, setIsSidebar] = useState(false);
  useEffect(() => {
    for (let i = 0; i < routesArr.length; i++) {

      if (routesArr[i].collapse == true) {
        for (let j = 0; j < routesArr[i].views.length; j++) {
          if (location.pathname == `${routesArr[i].views[j].layout}${routesArr[i].views[j].path}`) {
            setIsSidebar(routesArr[i].views[j].isSidebar);
          }
        }
      }
      else {
        if (location.pathname.includes("/admin/vendor-list-details")
          || location.pathname.includes("/admin/edit-onboarding-from")
          || location.pathname.includes("/admin/profile")
          || location.pathname.includes("/admin/Buyer-Bidding-Rfq-Creaction-Form")
          || location.pathname.includes("/admin/Buyer-Bidding-Commercial-Evaluation")
          || location.pathname.includes("/Engineering-Bidding-Technical-Evaluation")
          || location.pathname.includes("/Buyer-Bidding-Commercial-Comparision-Round-1")
          || location.pathname.includes("/Buyer-Bidding-Commercial-Comparison")
          || location.pathname.includes("/admin/po-detail-services")
          || location.pathname.includes("/admin/Project-Manager-Package-Detail")
          || location.pathname.includes("/admin/hod_vendor_performance_evaluation")
          || location.pathname.includes("/admin/vendor-LR-Deatil")
          || location.pathname.includes("/admin/grn-deatil")
          || location.pathname.includes("/admin/po-modification-detail")
          || location.pathname.includes("/admin/Vendor-Purchase-Detail")
          || location.pathname.includes("/admin/qc-detail")
          || location.pathname.includes("/admin/nfa-approval")
          || location.pathname.includes("/admin/vendor-Gate-Entry-Detail")
          || location.pathname.includes("/admin/Project-Manager-Detail")) {
          setIsSidebar(routesArr[i].isSidebar);
        }
        else if (location.pathname == `${routesArr[i].layout}${routesArr[i].path}`) {
          setIsSidebar(routesArr[i].isSidebar);
        }
      }
    }
  }, [location.pathname]);

  // const activeRoute = routeName => { 
  //     return location.pathname == routeName ? "sidebar-active" : "";
  // };

  const handleNavigation = (param) => {
    props.handleNavigation(param);
  }

  return (
    <>
      <section className="bg-form-color">
        <div className="container-fluid">
          <div className="row">
            {(isSidebar) && <div className={isSidebar ? 'col-md-2 left_menu' : 'left_menu'}>
              <Sidebar handleNavigation={handleNavigation} />
            </div>}

            <div className={isSidebar ? 'col-md-10' : 'col-md-12'}>
              <PreviousLocationProvider>
                <Routes>
                  {getRoutes(routesArr)}
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                </Routes>
              </PreviousLocationProvider>
            </div>

          </div>
        </div>

      </section>
    </>
  );
}

export default WithSidebar;
